import { render } from "./SeolqiChairV2.vue?vue&type=template&id=0f0165e5&scoped=true"
import script from "./SeolqiChairV2.vue?vue&type=script&lang=js"
export * from "./SeolqiChairV2.vue?vue&type=script&lang=js"

import "./SeolqiChairV2.vue?vue&type=style&index=0&id=0f0165e5&scoped=true&lang=css"
import "./SeolqiChairV2.vue?vue&type=style&index=1&id=0f0165e5&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f0165e5"]])

export default __exports__